// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconPencil = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M45.3456 27.1397L21.499 50.9863C20.5179 51.9674 19.6884 52.4801 18.372 52.9189L9.33306 55.9318C8.45963 56.223 7.77703 55.5404 8.06817 54.6669L11.0811 45.628C11.5199 44.3117 12.0326 43.4821 13.0137 42.501L36.8603 18.6545C37.7329 17.7818 38.8161 17.7818 39.6887 18.6545L45.3456 24.3113C46.2182 25.1839 46.2182 26.2671 45.3456 27.1397ZM55.3456 14.3113L49.6887 8.65448C48.8161 7.78186 47.7329 7.78182 46.8603 8.65448L42.6545 12.8602C41.7819 13.7328 41.7819 14.816 42.6545 15.6886L48.3114 21.3455C49.184 22.2181 50.2672 22.2181 51.1398 21.3455L55.3456 17.1398C56.2182 16.2671 56.2182 15.1839 55.3456 14.3113Z" />
    </svg>
  );
};
